import { render, staticRenderFns } from "./iconsort.vue?vue&type=template&id=138cf7f3&scoped=true&"
import script from "./iconsort.vue?vue&type=script&lang=js&"
export * from "./iconsort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138cf7f3",
  null
  
)

export default component.exports